import { wclFetch } from "./helpers.js";

document.addEventListener('DOMContentLoaded', () => {
    const portfolioBlocks = document.querySelectorAll('.wcl-portfolio-block');

    if ( !portfolioBlocks.length ) return;

    portfolioBlocks.forEach(block => {
        const categoryList = block.querySelectorAll('.category-item');
        const wrapper = block.querySelector('.portfolio');
        const loadMoreBtnWrapper = block.querySelector('.button');
        const loadMoreBtn = block.querySelector('.wcl-button');

        if ( !categoryList.length && wrapper ) return;

        const msnry = new Masonry(wrapper, {
            itemSelector: '.portfolio-item',
            percentPosition: true,
        });

        imagesLoaded(wrapper, () => msnry.layout());

        categoryList.forEach(item => {
            item.addEventListener('click', async ( e ) => {
                e.preventDefault();

                if ( item.classList.contains('active') ) return;

                // Remove the 'active' class from all elements
                categoryList.forEach(( el ) => el.classList.remove('active'));

                // Add the 'active' class to the current element
                item.classList.add('active');

                const category = item.dataset.cat

                const data = new FormData();

                data.append('action', 'get_portfolio_by_category');
                data.append('category', category);

                wrapper.classList.add('loading');
                loadMoreBtn.classList.add('loading');

                try {
                    const response = await wclFetch(data);

                    if ( !response.ok ) {
                        throw new Error('Unable to fetch data');
                    }

                    const result = await response.json();

                    if ( result.success == '1' ) {
                        wrapper.innerHTML = result.post_markup;

                        loadMoreBtn.dataset.page = '1';
                        loadMoreBtnWrapper.style.display = result.load_more ? 'block' : 'none';

                        msnry.reloadItems();
                        msnry.layout();
                    } else {
                        throw result.message;
                    }
                } catch ( error ) {
                    console.error(error);
                } finally {
                    wrapper.classList.remove('loading');
                    loadMoreBtn.classList.remove('loading');
                }
            });
        });

        if ( !loadMoreBtn ) return;

        loadMoreBtn.addEventListener('click', async e => {
            let currentPage = Number(loadMoreBtn.dataset.page);

            const data = new FormData();

            data.append('action', 'get_portfolio_by_page');
            data.append('page', currentPage);

            wrapper.classList.add('loading');
            loadMoreBtn.classList.add('loading');

            try {
                const response = await wclFetch(data);

                if ( !response.ok ) {
                    throw new Error('Unable to fetch data');
                }

                const result = await response.json();

                if ( result.success == '1' ) {
                    const frag = document.createRange().createContextualFragment(result.post_markup);
                    const newElems = frag.querySelectorAll('.portfolio-item');

                    wrapper.appendChild(frag);

                    msnry.appended(newElems);
                    msnry.layout();

                    currentPage++;
                    loadMoreBtn.dataset.page = currentPage;

                    loadMoreBtnWrapper.style.display = result.load_more ? 'block' : 'none';
                } else {
                    throw result.message;
                }
            } catch ( error ) {
                console.error(error);
            } finally {
                wrapper.classList.remove('loading');
                loadMoreBtn.classList.remove('loading');
            }
        });
    });
});